import { useWeb3 } from '../contexts/Web3Context';

/**
 * Footer - Application footer with branding and links.
 */

const Footer = () => {
  const { contractAddress } = useWeb3();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto py-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Branding */}
          <div className="text-text-muted text-sm">
            powered by{' '}
            <a
              href="https://subscrypts.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-muted hover:text-accent transition-colors"
            >
              subscrypts.com
            </a>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <a
              href="https://docs.subscrypts.com/discord-bot"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-muted hover:text-white transition-colors"
            >
              Docs
            </a>
            <a
              href="https://discord.gg/6uYzBUhAj7"
              target="_blank"
              rel="noopener noreferrer"
              className="text-text-muted hover:text-white transition-colors"
            >
              Discord
            </a>
            {contractAddress && (
              <a
                href={`https://arbiscan.io/address/${contractAddress}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-text-muted hover:text-white transition-colors"
              >
                Contract
              </a>
            )}
          </div>

          {/* Copyright */}
          <div className="text-text-muted text-sm">
            © {currentYear} Subscrypts
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
